export const BUY_URL = "https://www.motousher.com/collections/ebc-brakes";

export const PADS = [
  {
    id: "double-h",
    num: "01",
    name: "Double-H™",
    tag: "Sintered Superbike",
    desc: "The flagship standard — much-acclaimed sintered pads with superb stopping power for elite street and track control.",
    image: "https://images.unsplash.com/photo-1762012507780-060fe0bcc783?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    accent: "gold",
    span: "md:col-span-8",
    feature: true,
  },
  {
    id: "sintered",
    num: "02",
    name: "Sintered",
    tag: "Copper Alloy",
    desc: "Maximum durability and heat resistance engineered for hardcore endurance riding.",
    image: "https://images.unsplash.com/photo-1593855647955-31f5b8e692fa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    accent: "red",
    span: "md:col-span-4",
  },
  {
    id: "semi-sintered",
    num: "03",
    name: "Semi-Sintered",
    tag: "V-Pads™ Touring",
    desc: "The perfect blend of organic feel and sintered longevity — high-mileage, super quiet.",
    image: "https://images.unsplash.com/photo-1653654299266-13d03a47502d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    accent: "red",
    span: "md:col-span-4",
  },
  {
    id: "epfa",
    num: "04",
    name: "EPFA",
    tag: "Fast Street / Trackday",
    desc: "High-friction sintered pad with powerful, super-quiet braking for heavier, faster bikes.",
    image: "https://images.unsplash.com/photo-1767480350744-cedbd2757cdd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    accent: "red",
    span: "md:col-span-4",
  },
  {
    id: "gpfa",
    num: "05",
    name: "GPFAX",
    tag: "Sintered Race",
    desc: "Ultra-high-performance ZERO-fade race pad — a favourite of MotoGP teams worldwide.",
    image: "https://images.pexels.com/photos/30304161/pexels-photo-30304161.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1000",
    accent: "red",
    span: "md:col-span-4",
  },
];

export const ROTORS = [
  {
    id: "md",
    num: "01",
    name: "MD Contour Series",
    tag: "Stainless Rotors",
    desc: "British-made in German mill-rolled precision stainless steel — the perfect OEM replacement with premium engineering.",
    image: "https://images.unsplash.com/photo-1682189165011-d4305d2b0ced?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: "vee",
    num: "02",
    name: "Vee-Rotors™",
    tag: "Vee Profile Floating",
    desc: "Fully-floating lightweight design that reduces unsprung weight and delivers rapid cooling under load.",
    image: "https://images.pexels.com/photos/37811569/pexels-photo-37811569.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1400",
  },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1630872268379-6a585df2c1e7?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";
